import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type DevelopmentalSummaryType = {
  id: string | null;
  adaptiveComment: string | null;
  socialEmotionalComment: string | null;
  communicationComment: string | null;
  motorComment: string | null;
  cognitionComment: string | null;
  sessionReviewedDate: string | null;
};

export type IfspReportDevelopmentalSummaryType = {
  ifspId: string | null;
  developmentalSummary: DevelopmentalSummaryType[];
  heldBy: string | null;
  isCurrentlyHeld: boolean;
};

export type IfspReportDevelopmentalSummaryTypeStateType = {
  originalIfspDevelopmentSummaryReport: IfspReportDevelopmentalSummaryType;
  ifspDevelopmentSummaryReport: IfspReportDevelopmentalSummaryType;
};

export const initialIfspDevelopmentSummaryReportState: IfspReportDevelopmentalSummaryTypeStateType =
  {
    originalIfspDevelopmentSummaryReport: {
      ifspId: null,
      developmentalSummary: [],
      heldBy: null,
      isCurrentlyHeld: false,
    },
    ifspDevelopmentSummaryReport: {
      ifspId: null,
      developmentalSummary: [],
      heldBy: null,
      isCurrentlyHeld: false,
    },
  };

const ifspDevelopmentSummarySlice = createSlice({
  name: 'ifspDevelopmentSummaryReport',
  initialState: initialIfspDevelopmentSummaryReportState,
  reducers: {
    setIfspDevelopmentSummaryReport: (
      state,
      action: PayloadAction<IfspReportDevelopmentalSummaryType>,
    ) => {
      state.ifspDevelopmentSummaryReport = action.payload;
      state.originalIfspDevelopmentSummaryReport = action.payload;
    },
    updateIfspDevelopmentSummaryReport: (
      state,
      action: PayloadAction<Partial<IfspReportDevelopmentalSummaryType>>,
    ) => {
      state.ifspDevelopmentSummaryReport = {
        ...state.ifspDevelopmentSummaryReport,
        ...action.payload,
      };
    },
    updateOriginalIfspDevelopmentSummaryReport: (
      state,
      action: PayloadAction<Partial<IfspReportDevelopmentalSummaryType>>,
    ) => {
      state.originalIfspDevelopmentSummaryReport = {
        ...state.originalIfspDevelopmentSummaryReport,
        ...action.payload,
      };
    },

    resetIfspDevelopmentSummaryReport: () =>
      initialIfspDevelopmentSummaryReportState,
  },
  extraReducers: (builder) => {
    builder.addCase(
      'RESET_REDUX_APP_STATES',
      () => initialIfspDevelopmentSummaryReportState,
    );
  },
});

export const {
  setIfspDevelopmentSummaryReport,
  updateIfspDevelopmentSummaryReport,
  updateOriginalIfspDevelopmentSummaryReport,
  resetIfspDevelopmentSummaryReport,
} = ifspDevelopmentSummarySlice.actions;

export default ifspDevelopmentSummarySlice.reducer;
